import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

function Footer() {
    return (
        <footer className="cfs-footer">
            <div className="footer-body">

                {/* ========== LOGO + TAGLINE ========== */}
                <div className="footer-col">
                    <img
                        src="/images/PloughBreakersLogoWhite.svg"
                        className="footer-logo"
                        alt="Plough Breakers"
                    />
                    <p className="footer-tagline">
                        Specialist Kverneland plough parts,<br />
                        supplied direct from Kirriemuir, Angus.
                    </p>
                </div>

                {/* ========== MENU ========== */}
                <div className="footer-col">
                    <h3>Menu</h3>
                    <a href="/category/1">Machinery</a>
                    <a href="/category/2">Plough Parts</a>
                    <a href="/about">About</a>
                    <a href="/contact">Contact</a>
                    <Link to="/privacy-policy">Privacy Policy</Link>
                </div>

                {/* ========== CONTACT ========== */}
                <div className="footer-col">
                    <h3>Contact</h3>
                    <p>2 Little Herdhill Way</p>
                    <p>Kirriemuir, Angus</p>
                    <p>DD8 5JZ</p>
                    <p className="footer-contact-line" style={{ marginTop: 14 }}>
                        <i className="fas fa-phone-alt footer-contact-icon" />
                        07970 506155
                    </p>
                    <p className="footer-contact-line">
                        <i className="fas fa-envelope footer-contact-icon" />
                        info@ploughbreakers.co.uk
                    </p>
                    <p className="footer-contact-line">
                        <i className="fab fa-whatsapp footer-contact-icon" />
                        WhatsApp Enquiry
                    </p>
                </div>

            </div>

            <div className="footer-bottom">
                © {new Date().getFullYear()} Plough Breakers — All Rights Reserved.
                <span className="footer-bottom-sep">|</span>
                <Link to="/privacy-policy" className="footer-privacy-link">Privacy Policy</Link>
            </div>
        </footer>
    );
}

export default Footer;